<template>
  <article class="sa-rep-metric">
    <span class="sa-rep-metric__label">{{ label }}</span>
    <strong class="sa-rep-metric__value">{{ value }}</strong>
    <span v-if="hint" class="sa-rep-metric__hint">{{ hint }}</span>
  </article>
</template>

<script>
export default {
  name: 'ReportSummaryMetric',
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    hint: { type: String, default: '' },
  },
};
</script>

<style scoped>
.sa-rep-metric {
  min-width: 0;
  padding: 0.85rem 1rem;
  background: #f8f9fc;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 10px;
}

.sa-rep-metric__label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dashboard-muted, #697386);
}

.sa-rep-metric__value {
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--dashboard-text, #191c24);
  letter-spacing: -0.01em;
  word-break: break-word;
}

.sa-rep-metric__hint {
  display: block;
  margin-top: 0.3rem;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}
</style>
